import { StyleSheet, Dimensions } from 'react-native';
import Color from './Color';
import CommonProperties from './CommonProperties';
const screenDimensions = Dimensions.get('screen');
const { height, width } = screenDimensions;
const isPortrait = height > width;
const screenWidth = isPortrait ? width : height;
const screenHeight = isPortrait ? height : width;

const portraitMarginHorizontal = 20;
const CCPortraitWidth = screenWidth - portraitMarginHorizontal * 2;
const CCPortraitHeight = CCPortraitWidth * 0.62;
const CommonCreditCardStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    overflow: 'hidden',
    elevation: 10, // Shadow size
    // below shadow effect for web
    shadowOpacity: 0.4,
    shadowRadius: 6,
    shadowOffset: {
      width: 1,
      height: 3,
    },
    backgroundColor: Color.primaryEasyCard,
  },
});
export const CommonPortraitCreditCardStyles = StyleSheet.create({
  container: {
    ...CommonCreditCardStyles.container,
    height: CCPortraitHeight,
    width: CCPortraitWidth,
    marginHorizontal: portraitMarginHorizontal,
    borderRadius: 10,
  },
});

const landscapeMarginVertical = 24;
const CCLandscapeHeight = screenWidth - landscapeMarginVertical * 2;
const CCLandscapeWidth = CCLandscapeHeight * 1.61;
export const CommonLandscapeCreditCardStyles = StyleSheet.create({
  container: {
    ...CommonCreditCardStyles.container,
    height: CCLandscapeHeight,
    width: CCLandscapeWidth,
    borderRadius: 15,
  },
});

const commonStyles = StyleSheet.create({
  sideCommonProperties: {
    flex: 1,
    padding: 1,
    justifyContent: 'center',
  },
  chipIconCommonProperties: { justifyContent: 'center', textAlignVertical: 'center' },
  footerCommonProperties: {
    justifyContent: 'center',
    textAlignVertical: 'center',
  },
});

const portraitCommonStyles = StyleSheet.create({
  sideCommonProperties: {
    ...commonStyles.sideCommonProperties,
    height: CCPortraitHeight,
  },
  titleCommonProperties: {
    ...CommonProperties.creditCardFontFamily,
    fontSize: CCPortraitWidth * 0.0872,
  },
  chipIconCommonProperties: {
    ...commonStyles.chipIconCommonProperties,
    height: CCPortraitHeight * 0.26,
  },
  cardNumberCommonProperties: {
    ...CommonProperties.creditCardFontFamily,
    fontSize: CCPortraitWidth * 0.0726,
    height: CCPortraitHeight * 0.2,
  },
  footerCommonProperties: {
    ...commonStyles.footerCommonProperties,
    height: CCPortraitHeight * 0.17,
  },
});

const validThruColor = Color.secondaryEasyCard;
export const PortraitStyles = StyleSheet.create({
  titleContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  cardNumberContainer: {
    height: CCPortraitHeight * 0.28,
    justifyContent: 'center',
    textAlignVertical: 'center',
  },
  leftSideContainer: {
    ...portraitCommonStyles.sideCommonProperties,
    backgroundColor: Color.secondaryEasyCard,
  },
  leftTitleText: {
    ...portraitCommonStyles.titleCommonProperties,
    textAlign: 'right',
    color: Color.primaryEasyCard,
  },
  leftChipIconContainer: {
    ...portraitCommonStyles.chipIconCommonProperties,
    paddingBottom: 3,
  },
  chipIconStyle: {
    width: CCPortraitHeight * 0.22 * 1.6,
    height: CCPortraitHeight * 0.22,
    marginLeft: 10,
  },
  leftCardNumberText: {
    ...portraitCommonStyles.cardNumberCommonProperties,
    textAlign: 'right',
  },
  leftFooterContainer: {
    ...portraitCommonStyles.footerCommonProperties,
    ...CommonProperties.creditCardFontFamily,
    padding: 5,
  },
  divider: {
    width: 0,
  },
  rightSideContainer: {
    ...portraitCommonStyles.sideCommonProperties,
    backgroundColor: Color.primaryEasyCard,
  },
  rightTitleText: {
    ...portraitCommonStyles.titleCommonProperties,
    color: Color.secondaryEasyCard,
    textAlign: 'left',
  },
  rightChipIconContainer: {
    ...portraitCommonStyles.chipIconCommonProperties,
  },
  rightCardNumberText: {
    ...portraitCommonStyles.cardNumberCommonProperties,
    textAlign: 'left',
  },
  rightFooterContainer: {
    ...portraitCommonStyles.footerCommonProperties,
    alignItems: 'flex-end',
  },
  visaIconStyle: {
    width: CCPortraitHeight * 0.08 * 2.95,
    height: CCPortraitHeight * 0.08,
    marginRight: 10,
  },
  CVVText: { fontSize: CCPortraitWidth * 0.0377, marginLeft: 14, color: Color.primaryEasyCard },
  validThruLabel: {
    fontSize: CCPortraitWidth * 0.0261,
    lineHeight: CCPortraitWidth * 0.0263,
    color: validThruColor,
  },
  validThruText: { fontSize: CCPortraitWidth * 0.0377, color: validThruColor },
  cardCVVContainer: {
    height: CCPortraitHeight * 0.15,
    justifyContent: 'center',
  },
  validThruContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 10,
  },
  cardNameText: {
    marginLeft: 10,
    fontSize: CCPortraitWidth * 0.0436,
    color: Color.primaryEasyCard,
    lineHeight: CCPortraitWidth * 0.0448,
  },
});

const landscapeCommonStyles = StyleSheet.create({
  sideCommonProperties: {
    ...commonStyles.sideCommonProperties,
    height: CCLandscapeHeight,
  },
  titleCommonProperties: {
    ...CommonProperties.creditCardFontFamily,
    fontSize: CCLandscapeWidth * 0.0925,
  },
  chipIconCommonProperties: {
    ...commonStyles.chipIconCommonProperties,
    height: CCLandscapeHeight * 0.26,
  },
  cardNumberCommonProperties: {
    ...CommonProperties.creditCardFontFamily,
    fontSize: CCLandscapeWidth * 0.074,
  },
  footerCommonProperties: {
    ...commonStyles.footerCommonProperties,
    height: CCLandscapeHeight * 0.17,
  },
});

export const LandscapeStyles = StyleSheet.create({
  titleContainer: {
    flex: 1,
    height: CCLandscapeHeight * 0.3,
    justifyContent: 'center',
  },
  cardNumberContainer: {
    height: CCLandscapeHeight * 0.38,
    justifyContent: 'center',
    textAlignVertical: 'center',
  },
  leftSideContainer: {
    ...landscapeCommonStyles.sideCommonProperties,
    backgroundColor: Color.secondaryEasyCard,
  },
  leftTitleText: {
    ...landscapeCommonStyles.titleCommonProperties,
    textAlign: 'right',
    color: Color.primaryEasyCard,
  },
  leftChipIconContainer: {
    ...landscapeCommonStyles.chipIconCommonProperties,
  },
  chipIconStyle: {
    width: CCLandscapeHeight * 0.22 * 1.6,
    height: CCLandscapeHeight * 0.22,
    marginLeft: 10,
  },
  leftCardNumberText: {
    ...landscapeCommonStyles.cardNumberCommonProperties,
    textAlign: 'right',
  },
  leftFooterContainer: {
    ...landscapeCommonStyles.footerCommonProperties,
    ...CommonProperties.creditCardFontFamily,
    padding: 5,
  },
  divider: {
    width: 0,
  },
  rightSideContainer: {
    ...landscapeCommonStyles.sideCommonProperties,
    backgroundColor: Color.primaryEasyCard,
  },
  rightTitleText: {
    ...landscapeCommonStyles.titleCommonProperties,
    color: Color.secondaryEasyCard,
    textAlign: 'left',
  },
  rightChipIconContainer: {
    ...landscapeCommonStyles.chipIconCommonProperties,
  },
  rightCardNumberText: {
    ...landscapeCommonStyles.cardNumberCommonProperties,
    textAlign: 'left',
  },
  rightFooterContainer: {
    ...landscapeCommonStyles.footerCommonProperties,
    alignItems: 'flex-end',
  },
  visaIconStyle: {
    width: CCLandscapeHeight * 0.08 * 2.95,
    height: CCLandscapeHeight * 0.08,
    marginRight: 10,
  },
  CVVText: { fontSize: CCLandscapeWidth * 0.04, marginLeft: 14, color: Color.primaryEasyCard },
  validThruLabel: {
    fontSize: CCLandscapeWidth * 0.024,
    lineHeight: CCLandscapeWidth * 0.026,
    color: validThruColor,
  },
  validThruText: { fontSize: CCLandscapeWidth * 0.04, color: validThruColor },
  cardCVVContainer: {
    height: CCLandscapeHeight * 0.15,
    justifyContent: 'center',
    paddingTop: CCLandscapeHeight * 0.05,
  },
  validThruContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 10,
  },
  cardNameText: {
    marginLeft: 10,
    fontSize: CCLandscapeWidth * 0.04,
    color: Color.primaryEasyCard,
    lineHeight: CCLandscapeWidth * 0.042,
  },
});
